import React from 'react';
import { CustomInput } from 'reactstrap';
import { useFormInput } from '@sharingapples/form'; 

import {
  InputWithError,
  LabelledRadio,
  LabelledCheckboxes,
} from './imports';


const ExperienceOptions = [
  { label: '1+ Year', value: '1' },
  { label: '3+ Years', value: '3' },
  { label: '5+ Years', value: '5' },
  { label: '10+ Years', value: '10' },
];

const Languages = [
  { label: 'English', value: 'English' },
  { label: 'Chinese', value: 'Chinese' },
  { label: 'German', value: 'German' },
  { label: 'Russian', value: 'Russian' },
  { label: 'Hindi', value: 'Hindi' },
  { label: 'French', value: 'French' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Korean', value: 'Korean' },
];

const BaseCityOptions = [
  { label: 'Lukla', value: 'lukla' },
  { label: 'Pokhara', value: 'pokhara' },
  { label: 'Kathmandu', value: 'kathmandu' },
];

export default function GuideFiltersGroup() {
  return (
    <>
      <InputWithError
        Type={SwitchInput}
        name="femaleOnly"
        label="Female Guide Only"
        />
      <InputWithError
        showReset
        Type={LabelledRadio}
        name="baseCity"
        label="Based In"
        options={BaseCityOptions}
      />
      <InputWithError
        Type={LabelledCheckboxes}
        name="languages"
        options={Languages}
        label="Language"
      />
      <InputWithError
        showReset
        Type={LabelledRadio}
        name="experience"
        options={ExperienceOptions}
        label="Experience"
      />
    </>
  );
}

function SwitchInput(props: Props) {
  const { label, inputType, name, ...rest } = props;
  const [value, onChange] = useFormInput(name);

  const handleChange = React.useCallback(
    e => {
      return onChange(e.target.checked);
    },
    [onChange]
  );

  return (
    <CustomInput
      type="switch"
      id={label}
      name={label}
      label={label}
      checked={value}
      onChange={handleChange}
      {...rest}
    />
  );
}
